import { Controller } from "@hotwired/stimulus";

// Pet type radio cards: picking "Other" reveals the "What kind of animal?"
// input.
export default class extends Controller {
  static targets = ["typeRadio", "detailWrap"];

  declare readonly typeRadioTargets: HTMLInputElement[];
  declare readonly detailWrapTarget: HTMLElement;

  connect() {
    this.sync();
  }

  sync() {
    const checked = this.typeRadioTargets.find((radio) => radio.checked);
    this.detailWrapTarget.classList.toggle("hidden", checked?.value !== "other");
  }
}
